





/* ============================================================
   Amari Carter — Theme JS
   ============================================================ */

(function () {
  'use strict';

  /* ── Money formatting — no decimals, ever ── */
  function formatMoney(cents) {
    const amount = Math.round(cents / 100);
    return amount.toLocaleString('en-US', {
      style: 'currency',
      currency: window.__currency || 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  }

  /* ── Cart AJAX helpers ── */
  const Cart = {
    async add(variantId, quantity = 1) {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity }),
      });
      if (!res.ok) throw new Error('Add to cart failed');
      return res.json();
    },

    async get() {
      const res = await fetch('/cart.js');
      return res.json();
    },

    async update(updates) {
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates }),
      });
      return res.json();
    },

    async change(line, quantity) {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line, quantity }),
      });
      return res.json();
    },
  };

  /* ── Update cart count in header ── */
  async function refreshCartCount() {
    const cart = await Cart.get();
    document.querySelectorAll('.ac-cart-count').forEach(el => {
      el.textContent = cart.item_count;
    });
  }

  /* ── Rebuild cart drawer body from cart.js data ── */
  function renderCartDrawerBody(cart) {
    const body = document.getElementById('cart-drawer-body');
    if (!body) return;

    if (!cart.items || cart.items.length === 0) {
      body.innerHTML = '<div class="cart-drawer-empty">Your bag is empty.</div>';
      return;
    }

    const itemsHtml = cart.items.map((item, i) => {
      const line = i + 1;
      const variantHtml = item.variant_title && item.variant_title !== 'Default Title'
        ? `<div class="cart-drawer-item-variant">${item.variant_title}</div>`
        : '';
      const price = formatMoney(item.line_price);
      return `
        <div class="cart-drawer-item" data-line="${line}">
          <a href="${item.url}" class="cart-drawer-img">
            <img src="${item.image}" alt="${item.product_title}" loading="lazy" width="200" height="267">
          </a>
          <div class="cart-drawer-item-info">
            <a href="${item.url}" class="cart-drawer-item-title">${item.product_title}</a>
            ${variantHtml}
            <div class="cart-drawer-item-price">${price}</div>
            <div class="cart-drawer-qty">
              <button class="cart-drawer-qty-btn" data-line="${line}" data-delta="-1" aria-label="Decrease">−</button>
              <span class="cart-drawer-qty-num">${item.quantity}</span>
              <button class="cart-drawer-qty-btn" data-line="${line}" data-delta="1" aria-label="Increase">+</button>
            </div>
            <button class="cart-drawer-remove" data-line="${line}">Remove</button>
          </div>
        </div>`;
    }).join('');

    const total = formatMoney(cart.total_price);

    body.innerHTML = `
      <div class="cart-drawer-items">${itemsHtml}</div>
      <div class="cart-drawer-footer">
        <div class="cart-drawer-total">
          <span class="cart-drawer-total-label">Total</span>
          <span class="cart-drawer-total-price">${total}</span>
        </div>
        <a href="/checkout" class="cart-drawer-checkout">Checkout</a>
      </div>`;

    bindCartDrawerItemEvents();
  }

  function bindCartDrawerItemEvents() {
    document.querySelectorAll('.cart-drawer-qty-btn').forEach(btn => {
      btn.addEventListener('click', async () => {
        const line = parseInt(btn.dataset.line);
        const delta = parseInt(btn.dataset.delta);
        const numEl = btn.closest('.cart-drawer-qty').querySelector('.cart-drawer-qty-num');
        const newQty = Math.max(0, parseInt(numEl.textContent) + delta);
        const cart = await Cart.change(line, newQty);
        renderCartDrawerBody(cart);
        await refreshCartCount();
      });
    });

    document.querySelectorAll('.cart-drawer-remove').forEach(btn => {
      btn.addEventListener('click', async () => {
        const line = parseInt(btn.dataset.line);
        const cart = await Cart.change(line, 0);
        renderCartDrawerBody(cart);
        await refreshCartCount();
      });
    });
  }

  /* ── ATC button ── */
  const atcForm = document.getElementById('ac-atc-form');
  if (atcForm) {
    atcForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = atcForm.querySelector('.btn-atc');
      const variantInput = atcForm.querySelector('[name="id"]');
      if (!variantInput || !variantInput.value) return;

      btn.disabled = true;
      btn.textContent = 'Adding...';

      try {
        await Cart.add(variantInput.value);
        const cart = await Cart.get();
        document.querySelectorAll('.ac-cart-count').forEach(el => {
          el.textContent = cart.item_count;
        });
        renderCartDrawerBody(cart);
        document.dispatchEvent(new CustomEvent('cart:item-added'));
        btn.textContent = 'Added';
        setTimeout(() => {
          btn.disabled = false;
          btn.textContent = 'Add to Cart';
        }, 1600);
      } catch {
        btn.disabled = false;
        btn.textContent = 'Add to Cart';
      }
    });
  }

  /* ── Variant selector ── */
  const swatchBtns = document.querySelectorAll('.swatch-btn');
  swatchBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const optionIndex = btn.dataset.optionIndex;
      document.querySelectorAll(`.swatch-btn[data-option-index="${optionIndex}"]`).forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      updateSelectedVariant();
    });
  });

  function updateSelectedVariant() {
    const selectedOptions = [];
    document.querySelectorAll('.product-option-swatches').forEach(group => {
      const active = group.querySelector('.swatch-btn.is-active');
      if (active) selectedOptions.push(active.dataset.value);
    });

    const variants = window.__variants || [];
    const match = variants.find(v =>
      v.options.every((opt, i) => opt === selectedOptions[i])
    );

    const variantInput = document.querySelector('[name="id"]');
    const priceEl = document.querySelector('#product-price');
    const btn = document.querySelector('.btn-atc');

    if (match) {
      if (variantInput) variantInput.value = match.id;
      if (priceEl) {
        const price = formatMoney(match.price);
        const compare = match.compare_at_price && match.compare_at_price > match.price
          ? `<s>${formatMoney(match.compare_at_price)}</s> `
          : '';
        priceEl.innerHTML = compare + price;
      }
      if (btn) {
        btn.disabled = !match.available;
        btn.textContent = match.available ? 'Add to Cart' : 'Sold Out';
      }

      // update gallery image if variant has one
      if (match.featured_image) {
        const main = document.getElementById('gallery-main-img');
        if (main) main.src = match.featured_image.src;
      }
    }
  }

  /* ── Product gallery thumbnails ── */
  const thumbBtns = document.querySelectorAll('.gallery-thumb-btn');
  thumbBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      thumbBtns.forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      const main = document.getElementById('gallery-main-img');
      if (main) main.src = btn.dataset.src;
    });
  });

  /* ── Cart page qty +/- ── */
  document.querySelectorAll('.cart-qty-change').forEach(btn => {
    btn.addEventListener('click', async () => {
      const line = parseInt(btn.dataset.line);
      const delta = parseInt(btn.dataset.delta);
      const qtyEl = btn.closest('.cart-qty').querySelector('.cart-qty-num');
      const currentQty = parseInt(qtyEl.textContent);
      const newQty = Math.max(0, currentQty + delta);
      await Cart.change(line, newQty);
      window.location.reload();
    });
  });

  document.querySelectorAll('.cart-remove').forEach(btn => {
    btn.addEventListener('click', async () => {
      const line = parseInt(btn.dataset.line);
      await Cart.change(line, 0);
      window.location.reload();
    });
  });

  /* ── Active nav link ── */
  const path = window.location.pathname;
  document.querySelectorAll('.ac-nav a').forEach(a => {
    if (a.getAttribute('href') === path) a.classList.add('is-active');
  });
  document.querySelectorAll('.ac-nav a.ac-nav-link').forEach(a => {
    if (a.getAttribute('href') === path) a.classList.add('is-active');
  });

  /* ── Init ── */
  refreshCartCount();
  bindCartDrawerItemEvents();
})();

/* ── Nav persistence — keep sub-columns open based on current URL ── */
(function () {
  var path = window.location.pathname;
  var nav = document.getElementById('ac-nav');
  if (!nav) return;

  var connector1 = document.getElementById('nav-connector-1');
  var connector2 = document.getElementById('nav-connector-2');

  function show(triggerId, depth) {
    var sub = nav.querySelector('[data-nav-sub="' + triggerId + '"][data-depth="' + depth + '"]');
    var btn = nav.querySelector('[data-nav-trigger="' + triggerId + '"]');
    if (sub) { sub.classList.add('is-visible'); }
    if (btn) { btn.classList.add('is-active'); btn.setAttribute('aria-expanded', 'true'); }
    if (depth === 2 && connector1) connector1.style.display = 'block';
    if (depth === 3 && connector2) connector2.style.display = 'block';
  }

  // Always show col-2 on any collection page
  if (path.indexOf('/collections') !== -1) {
    show('shop', 2);
  }

  // Show col-3 on clothing subcollection pages
  var clothingUrls = ['/collections/tops', '/collections/skirts', '/collections/trousers', '/collections/all'];
  for (var i = 0; i < clothingUrls.length; i++) {
    if (path.indexOf(clothingUrls[i]) !== -1) {
      show('shop-clothing', 3);
      break;
    }
  }

  // Remove entrance animations from already-visible items
  nav.querySelectorAll('.nav-col-sub.is-visible .ac-nav-link').forEach(function(el) {
    el.style.opacity = '1';
    el.style.animation = 'none';
  });
})();



/* ── Motion system ── */
(function () {

  /* IntersectionObserver — scroll reveals */
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.reveal').forEach(function (el) {
      observer.observe(el);
    });

    /* Also observe product cards for staggered entrance */
    document.querySelectorAll('.product-card').forEach(function (el, i) {
      el.classList.add('reveal');
      el.classList.add('reveal-delay-' + ((i % 4) + 1));
      observer.observe(el);
    });
  }

  /* Gallery image fade on thumb click */
  var mainImg = document.getElementById('gallery-main-img');
  if (mainImg) {
    document.querySelectorAll('.gallery-thumb-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        mainImg.classList.add('is-switching');
        setTimeout(function () {
          mainImg.src = btn.dataset.src;
          mainImg.classList.remove('is-switching');
        }, 180);
        document.querySelectorAll('.gallery-thumb-btn').forEach(function (b) {
          b.classList.remove('is-active');
        });
        btn.classList.add('is-active');
      });
    });
  }

  /* Announcement bar slide-out on close */
  var annClose = document.getElementById('announcement-close');
  var annBar   = document.getElementById('ac-announcement');
  if (annClose && annBar) {
    annClose.addEventListener('click', function () {
      annBar.classList.add('is-hidden');
      setTimeout(function () {
        document.body.style.paddingBottom = '0';
      }, 320);
      sessionStorage.setItem('ac-bar-closed', '1');
    });
    if (sessionStorage.getItem('ac-bar-closed')) {
      annBar.classList.add('is-hidden');
      document.body.style.paddingBottom = '0';
    }
  }

})();

/* ── Set page-wrap padding to match actual header height ── */
(function () {
  function setHeaderOffset() {
    var header = document.getElementById('ac-header');
    var wrap   = document.querySelector('.page-wrap');
    if (!header || !wrap) return;
    wrap.style.paddingTop = header.offsetHeight + 'px';
  }
  setHeaderOffset();
  window.addEventListener('resize', setHeaderOffset);
})();


/* ── Mobile product details toggle ── */
(function () {
  var toggle  = document.getElementById('mob-details-toggle');
  var panel   = document.getElementById('mob-product-details');
  if (!toggle || !panel) return;

  toggle.addEventListener('click', function () {
    var isOpen = !panel.hidden;
    if (isOpen) {
      panel.hidden = true;
      toggle.classList.remove('is-open');
      toggle.querySelector('.mob-details-toggle-icon').textContent = '+';
    } else {
      panel.hidden = false;
      toggle.classList.add('is-open');
      toggle.querySelector('.mob-details-toggle-icon').textContent = '−';
    }
  });
})();


/* ── Smooth anchor scroll (Safari fallback) ── */
(function () {
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a) return;
    var id = a.getAttribute('href').slice(1);
    if (!id) return;
    var target = document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();
